import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import {
  ACTION_ADD,
  ACTION_INIT,
  ACTION_REMOVE,
  UPDATE,
  NAME,
  ACTION_CLEAR,
  ACTION_WRITE_ITEMS,
  UPDATE_FOR_LOADING,
} from './consts';
import Repo from './repo';
import { Providers, RootState, State } from './types';

const createModule = ({ $config }: Providers) => {
  let storage;
  try {
    storage = localStorage;
  } catch (e) {}
  const repo = new Repo(NAME, storage);

  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class ModuleBasketStore extends VuexModule<State, RootState> {
    // State
    items: any = [];
    ready: boolean = false;
    show: boolean = true;

    // Mutations
    @Mutation
    [UPDATE](items: any) {
      this.ready = true;
      this.items = items;
    }

    // Mutations
    @Mutation
    [UPDATE_FOR_LOADING](value: any) {
      this.show = value.show;
      this.items = value.items;
    }

    // Actions
    @Action({ commit: UPDATE })
    async [ACTION_ADD](item: any) {
      return repo.add(item);
    }

    @Action({ commit: UPDATE })
    async [ACTION_INIT]() {
      return repo.load();
    }

    @Action({ commit: UPDATE })
    async [ACTION_REMOVE](id: any) {
      return repo.remove(id);
    }

    @Action({ commit: UPDATE })
    async [ACTION_CLEAR]() {
      return repo.clear();
    }

    @Action({ commit: UPDATE_FOR_LOADING })
    async [ACTION_WRITE_ITEMS](value: any) {
      const items = value.items;
      const show = value.show;
      return { items, show };
    }
  }

  return ModuleBasketStore;
};

export default createModule;



// WEBPACK FOOTER //
// ./src/services/modulebasket/store.ts